<template>
  <div
    :class="[
      'img-loader',
      computedSize,
      { active: active === true },
      { fallback: fallback === true }
    ]"
  >
    <img ref="img" />
    <div class="fallback">
      <span>
        {{ initial }}
      </span>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: function() {
    var obj = {
      active: false,
      fallback: false
    };
    return obj;
  },
  props: ["src", "initial", "size"],
  watch: {
    src: {
      handler: function() {
        this.loadImage();
      },
      immediate: false
    }
  },
  computed: {
    computedSize: function() {
      return this.size || "md";
    }
  },
  methods: {
    loadImage: function() {
      var _img = this.$refs.img;
      var newImg = new Image();
      newImg.onload = () => {
        _img.src = this.src;
        this.active = true;
      };
      newImg.onerror = () => {
        this.active = true;
        this.fallback = true;
      };
      newImg.src = this.src;
    }
  },
  mounted: function() {
    this.loadImage();
  }
};
</script>

<style lang="scss">
.img-loader {
  display: inline-block;
  position: relative;
  img {
    display: block;
    width: 100%;
    height: auto;
    opacity: 0;
    transition: opacity 100ms linear;
  }

  &.active {
    img {
      opacity: 1;
    }
  }
  .fallback {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.25rem;
    font-weight: 500;
    letter-spacing: -0.2px;
    text-align: center;
    color: var(--p1);
    transition: opacity 100ms linear;
    text-transform: capitalize;
    user-select: none;

    span {
      display: inline-block;
    }
  }
  &.sm {
    width: 24px;
    height: 24px;
    .fallback {
      font-size: 1rem;
    }
  }
  &.fallback {
    img {
      opacity: 0;
    }
    .fallback {
      opacity: 1;
    }
  }
}
</style>
